import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 841FF2DA-C31C-48B1-A566-10238590DAF9
 * name format-page-split
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-page-split.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatPageSplitIcon = createSvgIcon(<><path d="M11 11V7H13V11H11M13 1V5H11V1H13M11 17V13H13V17H11M9 20H6V4H9V2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H9V20M15 3V8H18V20H15V22H18C19.11 22 20 21.11 20 20V8L15 3M13 19H11V23H13V19Z" /></>, 'FormatPageSplitIcon');
export default FormatPageSplitIcon